import { menuActions } from "../../actionTypes";

const initialState = {
	menu: [],
	fetching: false,
	fetched: false,
	error: null,
};

export const menu = (state = initialState, action) => {
	switch (action.type) {
		case menuActions.FETCH_MENU: {
			return { ...state, fetching: true };
		}

		case menuActions.FETCH_MENU_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				menu: action.payload,
			};
		}

		case menuActions.FETCH_MENU_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
			return state;
	}
};
